window.$ = window.jQuery = require('jquery');
require('bootstrap');


// WEBPACK FOOTER //
// ./resources/views/rd/assets/js/v2/asyncVendor.js